
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useRef, useLayoutEffect } from 'react';
import gsap from 'gsap';
import { HashRouter as Router, Routes, Route, useParams, Link } from 'react-router-dom';
import './App.css';
import './Styles/98.css';
import './Styles/style.css';

import HomePage from './homepage';
import BackPage from './backpage';
import AboutPage from './Pages/AboutPage';
import Header from './Components/Header';
import ComicsPage from './Pages/ComicsPage';
import CodePage from './Pages/CodePage';
import ObjectsPage from './Pages/3DObjectsPage';
import EnvironmentPage from './Pages/EnvironmentPage';
import ContactPage from './Pages/ContactPage';
import RandomThoughts from './Pages/RandomThoughts';
import Roblox from './Pages/Roblox';
import Resume from './Pages/Resume';
import XarasGuide from './Pages/XarasGuide';
import Essays from './Pages/Essays';

import Highlight1Page from './Pages/Highlights/Highlight1';
import Highlight2Page from './Pages/Highlights/Highlight2';

import ComingSoon from './Pages/ComingSoon';

import background from "./images/viewOfCapri.jpg";
import {styleReset} from 'react95';
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
// pick a theme of your choice
// original Windows95 font (optionally)
import ms_sans_serif from 'react95/dist/fonts/ms_sans_serif.woff2';
import ms_sans_serif_bold from 'react95/dist/fonts/ms_sans_serif_bold.woff2';

const GlobalStyles = createGlobalStyle`
  ${styleReset}
  @font-face {
    font-family: 'ms_sans_serif';
    src: url('${ms_sans_serif}') format('woff2');
    font-weight: 400;
    font-style: normal
  }
  @font-face {
    font-family: 'ms_sans_serif';
    src: url('${ms_sans_serif_bold}') format('woff2');
    font-weight: bold;
    font-style: normal
  }
  body {
    font-family: 'ms_sans_serif';
  }
  h1 { font-size: 2rem; font-weight: bold; margin-bottom: 0.5rem; }
  h2 { font-size: 1.5rem; font-weight: bold; margin-bottom: 0.5rem; }
  h3 { font-size: 1.25rem; font-weight: bold; margin-bottom: 0.5rem; }
  h4 { font-size: 1rem; font-weight: bold; margin-bottom: 0.5rem; }
  p  { margin-bottom: 0.5rem; }
  ul { margin-left: 1.5rem; list-style: disc; }
`;


function App() {

  const Highlight1 = '/GlorgosMicroplastics'
  const Highlight2 = '/Boascope'

  return (
    <Router>
      <div id="page-root" style={{ backgroundImage: `url(${background})`, display: 'flex', flexDirection: 'column', overflow: 'hidden', position: 'relative', justifyContent: 'flex-end', backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', width: '100%', height: '100vh'}}>
  
        <div id="page-content" style={{display: 'flex', flex: 1, justifyContent: 'space-around', overflow: 'visible'}}>
          <GlobalStyles />
            
            <Routes>
                <Route path="/"  element={<HomePage/>} />
                    
                <Route path="/AboutPage" element={<AboutPage/>} />
                <Route path="/Backpage" element={<BackPage/>} />
                <Route path="/ComicsPage" element={<ComicsPage/>} />
                <Route path="/ObjectsPage" element={<ObjectsPage/>} />
                <Route path="/CodePage" element={<CodePage/>} />
                <Route path="/ComingSoon" element={<ComingSoon/>} />
                <Route path="/ContactPage" element={<ContactPage/>} />
                <Route path="/RandomThoughts" element={<RandomThoughts/>} />
                    <Route path="/RandomThoughts" element={<RandomThoughts/>} />
                    <Route path="/EnvironmentPage" element={<EnvironmentPage/>} />
                    <Route path="/Xarasguide" element={<XarasGuide/>} />
                    <Route path="/Essays/:slug" element={<Essays/>} />
                        
                    <Route path="/Boascope" element={<Highlight1Page/>} />
                    <Route path="/GlorgosMicroplastics" element={<Highlight2Page/>} />
                    <Route path="/Roblox" element={<Roblox/>} />
                <Route path="/Resume" element={<Resume/>} />
            </Routes>
            
          </div>
              
                        
          <Header/>
        </div>
    </Router>
        
  );
}


export const Highlight1 = "/Boascope";
export const Highlight2 = "/GlorgosMicroplastics";

export default App;
